import { DEFAULT_LOCALE, resolveLocale } from "./constants";
import { messages } from "./messages";

export function getMessage(locale, key) {
  return key
    .split(".")
    .reduce((value, segment) => value?.[segment], messages[resolveLocale(locale)]);
}

export function interpolate(template, params = {}) {
  if (typeof template !== "string") {
    return template;
  }

  return template.replace(/\{(\w+)\}/g, (_, key) => {
    return params[key] ?? `{${key}}`;
  });
}

export function translate(locale, key, params = {}) {
  const template =
    getMessage(locale, key) ?? getMessage(DEFAULT_LOCALE, key) ?? key;
  return interpolate(template, params);
}
